/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dienas",
                  "dienu",
                  "dienām",
                  "dienas",
                  "dienās",
                  "dienām",
                  "dienas"
            ],
            "singular": [
                  "diena",
                  "dienas",
                  "dienai",
                  "dienu",
                  "dienā",
                  "dienu",
                  "diena"
            ],
            "zero": [
                  "diena",
                  "dienu",
                  "dienām",
                  "dienas",
                  "dienās",
                  "dienām",
                  "dienas"
            ]
      },
      "hour": {
            "plural": [
                  "stundas",
                  "stundu",
                  "stundām",
                  "stundas",
                  "stundās",
                  "stundām",
                  "stundas"
            ],
            "singular": [
                  "stunda",
                  "stundas",
                  "stundas",
                  "stundu",
                  "stundā",
                  "stundu",
                  "stunda"
            ],
            "zero": [
                  "stundas",
                  "stundu",
                  "stundām",
                  "stundas",
                  "stundās",
                  "stundām",
                  "stundas"
            ]
      },
      "minute": {
            "plural": [
                  "minūtes",
                  "minūšu",
                  "minūtēm",
                  "minūtes",
                  "minūtēs",
                  "minūtēm",
                  "minūtes"
            ],
            "singular": [
                  "minūte",
                  "minūtes",
                  "minūtei",
                  "minūti",
                  "minūtē",
                  "minūti",
                  "minūte"
            ],
            "zero": [
                  "minūtes",
                  "minūšu",
                  "minūtēm",
                  "minūtes",
                  "minūtēs",
                  "minūtēm",
                  "minūtes"
            ]
      },
      "month": {
            "plural": [
                  "mēneši",
                  "mēnešu",
                  "mēnešiem",
                  "mēnešus",
                  "mēnešos",
                  "mēnešiem",
                  "mēneši"
            ],
            "singular": [
                  "mēnesis",
                  "mēneša",
                  "mēnesim",
                  "mēnesi",
                  "mēnesī",
                  "mēnesi",
                  "mēnesis"
            ],
            "zero": [
                  "mēnesis",
                  "mēnešu",
                  "mēnešiem",
                  "mēnešus",
                  "mēnešos",
                  "mēnešiem",
                  "mēneši"
            ]
      },
      "second": {
            "plural": [
                  "sekundes",
                  "sekunžu",
                  "sekundēm",
                  "sekundes",
                  "sekundēs",
                  "sekundēm",
                  "sekundes"
            ],
            "singular": [
                  "sekunde",
                  "sekundes",
                  "sekundei",
                  "sekundi",
                  "sekundē",
                  "sekundi",
                  "sekunde"
            ],
            "zero": [
                  "sekundes",
                  "sekunžu",
                  "sekundēm",
                  "sekundes",
                  "sekundēs",
                  "sekundēm",
                  "sekundes"
            ]
      },
      "year": {
            "plural": [
                  "gadi",
                  "gadu",
                  "gadiem",
                  "gadus",
                  "gados",
                  "gadiem",
                  "gadi"
            ],
            "singular": [
                  "gads",
                  "gada",
                  "gadam",
                  "gadu",
                  "gadā",
                  "gadu",
                  "gads"
            ],
            "zero": [
                  "gadi",
                  "gadu",
                  "gadiem",
                  "gadus",
                  "gados",
                  "gadiem",
                  "gadi"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
